var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Jobs {
    constructor(url) {
        this.url = "./../../static/rawJobs.json";
        if (url) {
            this.url = url;
        }
    }
    fetchRawJobs() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetch(this.url).then((response) => {
                if (!response.ok) {
                    console.error(`Could not fetch jobs from ${this.url}, response was: `, response);
                }
                return response.json();
            });
        });
    }
    transform(rawSearch) {
        return rawSearch.jobs.map((rawJob) => {
            return {
                corp: rawJob.firma,
                locations: [
                    {
                        lon: Number(rawJob.lng),
                        lat: Number(rawJob.lat),
                    },
                ],
                date: rawJob.datum,
                id: parseInt(rawJob.ID),
                logo: rawJob.logo,
                score: 0,
                title: rawJob.titel,
                type: rawJob.typ,
                url: rawJob.url,
                poked: false,
                liked: false,
                poketime: "0",
            };
        });
    }
    transformGoMatch(rawSearch) {
        return rawSearch.jobs.map((rawJob) => {
            return {
                corp: "null",
                locations: [
                    {
                        lon: Number(rawJob.lng),
                        lat: Number(rawJob.lat),
                    },
                ],
                date: rawJob.matchedat,
                id: parseInt(rawJob.id),
                logo: "null",
                score: rawJob.score,
                title: rawJob.title,
                type: "null",
                url: rawJob.url,
                poked: rawJob.poked,
                liked: rawJob.liked,
                poketime: rawJob.poketime,
            };
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const rawJobs = yield this.fetchRawJobs();
            return [this.transform(rawJobs), rawJobs.orte];
        });
    }
    getFromRawData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return [this.transform(data), data.orte];
        });
    }
    getFromGoMatchRawData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return [this.transformGoMatch(data), data.orte];
        });
    }
}
